document.addEventListener('turbo:load', () => {
  const userSelect = document.getElementById('time_entry_user_id')
  const rateInput = document.getElementById('time_entry_hourly_rate')

  if (userSelect && rateInput) {
    // Store user rates as data attributes on the select element
    userSelect.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0]

      if (selectedOption && selectedOption.value) {
        const userId = selectedOption.value
        const rate = selectedOption.getAttribute('data-hourly-rate')

        if (rate && rate !== '') {
          rateInput.value = parseFloat(rate).toFixed(2)
          // Trigger input event to update Cleave.js formatting
          rateInput.dispatchEvent(new Event('input', { bubbles: true }))
        }
      }
    })
  }
})
